import React from 'react';
import {AvatarContainer} from "./style";

export function Avatar ({ src, alt, size }) {
  return (
    <AvatarContainer rounded size={size}>
      <img src={src} alt={alt} />
    </AvatarContainer>
  );
}